import { NavLink, Outlet, useLocation } from "react-router-dom";

import { useAppSession } from "../../state/AppSessionContext.jsx";

const DASHBOARDS = [
  { to: "/", label: "Main Dashboard", hint: "your day, and how the last few went" },
  { to: "/money", label: "Expense Tracker", hint: "what you spent" },
  { to: "/food", label: "Diet Tracker", hint: "what you ate" },
  { to: "/work", label: "Task Tracker", hint: "what you got done" },
];

function initials(name) {
  const parts = String(name || "?").trim().split(/\s+/).slice(0, 2);
  return parts.map((p) => p[0]?.toUpperCase() ?? "").join("") || "?";
}

function greeting(hour) {
  if (hour < 5) return "Still up";
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  if (hour < 22) return "Good evening";
  return "Good night";
}

export default function Shell() {
  const { me, signOut } = useAppSession();
  const location = useLocation();

  const firstName = String(me?.name ?? "").trim().split(/\s+/)[0] || "there";
  let hour = new Date().getHours();
  try {
    hour = Number(
      new Intl.DateTimeFormat("en-GB", {
        timeZone: me?.timezone,
        hour: "2-digit",
        hourCycle: "h23",
      }).format(new Date()),
    );
  } catch {
    hour = new Date().getHours();
  }

  const active = DASHBOARDS.find((d) => d.to === location.pathname);

  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">
          <span className="brand-mark">R</span>
          <span className="brand-name">Rasmalai</span>
        </div>

        <div className="sidebar-scroll">
          <div className="sidebar-heading">Dashboards</div>
          {DASHBOARDS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) => `navitem${isActive ? " is-active" : ""}`}
            >
              {item.label}
            </NavLink>
          ))}

          <div className="sidebar-heading">Assistant</div>
          <div className="navitem is-disabled" title="Coming soon">
            Chat
            <span className="soon">soon</span>
          </div>
        </div>

        <div className="switcher">
          <div className="switcher-trigger as-static">
            <span className="avatar">{initials(me?.name)}</span>
            <span className="switcher-trigger-text">
              <span className="switcher-trigger-name">{me?.name ?? "—"}</span>
              <span className="switcher-trigger-meta">{me?.timezone ?? ""}</span>
            </span>
          </div>
          <button className="switcher-signout" onClick={signOut}>
            Sign out
          </button>
        </div>
      </aside>

      <main className="main">
        <header className="hero">
          <div>
            <h1>
              {greeting(hour)}, {firstName}
            </h1>
            <p className="hero-sub">{active?.hint ?? "your day, as Rasmalai has it"}</p>
          </div>
          <span className="hero-date">
            {new Date().toLocaleDateString("en-GB", {
              weekday: "long",
              day: "numeric",
              month: "long",
              timeZone: me?.timezone,
            })}
          </span>
        </header>

        <div className="page">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
